import { Button, Chip, Input, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SEO from /*'../../common/SEO'*/ "../../../src/common/SEO";
import Layout from "../../../src/common/Layout";

const HighestEduLevel = () => {
  const [clicked, setClicked] = useState(true);
  const [text, setText] = useState(null);

  const [ug, setug] = useState(false);
  const [pg, setpg] = useState(false);
  const [ud, setud] = useState(false);
  const [pd, setpd] = useState(false);


  const [errMessage, setErrMessage] = useState(false)

  const navigate = useNavigate();

  const handleClickUG = (e) => {
    setText(e.target.innerText);
    setug(true)
    // setErrMessage('')
    setpg(false)
    setud(false)
    setpd(false)
  };

  const handleClickPG = (e) => {
    setText(e.target.innerText);
    setpg(true)

    setug(false)
    setud(false)
    setpd(false)
  };

  const handleClickUD = (e) => {
    setText(e.target.innerText);
    setud(true)

    setug(false)
    setpg(false)
    setpd(false)
  };

  const handleClickPD = (e) => {
    setText(e.target.innerText);
    setpd(true)

    setug(false)
    setpg(false)
    setud(false)
  };

  const handleInputChange = (e) => {
    console.log(e.target.value)
    if (e.target.value < 33 || e.target.value > 100) {
      setErrMessage('Your percentage is low atleast 33% needed to proceed ahead and must be less than 100%')
    }
    else {
      setErrMessage(true)
    }
  }

  const handleClickButton = () => {
    navigate("/majorpursue");
  };

  return (
    <>
      <SEO title="CourseSelection" />
      <Layout>
        <div className="edu-course-area edu-section-gap bg-color-white rishabhCSSBackground">
          <div className="container">
            <div className=" grid h-screen place-items-center">
              <div className="flex flex-col h-screen place-items-center justify-center countryPicker">
        <div>
          <Typography color="secondary"
                    fontSize={28}
                    align="center"
                    className="mb-20 text-16 font-bold text-[#603aa2] textAboveCountry equalMargin">
            What is your highest education level?
          </Typography>
        </div>


        <div className="p-20  flex equalMargin">
          <Stack direction="row" spacing={1} className="crad cradFont" style={{fontSize:"50px"}}>
            <Chip
              className="p-20 rounded-full font-bold border-3 text-14"
              sx={{fontSize:"18px", color:"white"}}
              size="medium"
              label="Undergraduate Degree"
              style={{ backgroundColor: ug ? '#603aa2' : '#c59bdb' }}
              variant={ug ? 'filled' : 'outlined'}
              onClick={(e) => handleClickUG(e)}
            />
            <Chip
              className="p-20 rounded-full font-bold border-3 text-14"
              sx={{fontSize:"18px", color:"white"}}
              label="Postgarduate Degree"
              size="medium"
              style={{ backgroundColor: pg ? '#603aa2' : '#c59bdb' }}
              variant={pg ? 'filled' : 'outlined'}
              onClick={(e) => handleClickPG(e)}
            />
            <Chip
              className="p-20 rounded-full font-bold border-3 text-14"
              sx={{fontSize:"18px", color:"white"}}
              label="Undergraduate Diploma"
              size="medium"
              style={{ backgroundColor: ud ? '#603aa2' : '#c59bdb' }}
              variant={ud ? 'filled' : 'outlined'}
              onClick={(e) => handleClickUD(e)}
            />
            <Chip
              className="p-20 rounded-full font-bold border-3 text-14"
              sx={{fontSize:"18px", color:"white"}}
              label="Postgarduate Diploma"
              size="medium"
              style={{ backgroundColor: pd ? '#603aa2' : '#c59bdb' }}
              variant={pd ? 'filled' : 'outlined'}
              onClick={(e) => handleClickPD(e)}
            />
          </Stack>
        </div>

        { (ug || pg || ud || pd)  &&

          <>
            <div>

              <Typography fontSize={20}
                    align="center"
                    className="p-20  font-bold text-20 flex justify-center text-[#5D3FD3] textAboveCountry equalMargin">
                What is your expected or gained percentage in {text} ?
              </Typography>

            </div>

            <div className="flex flex-col justify-center equalMargin">  

              <center>
                <Input type="number" size="small" onChange={(e) => handleInputChange(e)} style={{ color: '#5D3FD3' }}  ></Input>
              </center>
              <Typography fontSize={18}
                    align="center"
                    className="p-20  font-bold text-20 flex justify-center text-[#5D3FD3] textAboveCountry equalMargin">{errMessage}</Typography>
            </div>
          </>
        }


        <div className="d-flex mt-5 items-center  justify-center crad">
          <Button
            variant="contained"
            size="large"
            onClick={handleClickButton}
            style={{ backgroundColor: "#603aa2", fontSize: "18px" }}
            disabled={errMessage == true ? false : true}
          >
            Continue
          </Button>
        </div>
        </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default HighestEduLevel;
